import logFactory, { LogLevels } from 'c9-js-log-client';

let logger: ReturnType<typeof logFactory> | undefined;

const defaultLogger = logFactory('console', 'ninja-schedule-a-callback-app', LogLevels.debug);

export const registerLogger = (logClient: typeof logger) => {
  logger = logClient;
};

const getLogger = () => logger ?? defaultLogger;

const writeLog = (level: 'info' | 'error' | 'warn' | 'debug', ...messages: any[]): Promise<void> => {
  const message = messages
    .map((msg) =>
      msg.stack
        ? `${JSON.stringify(msg)}\n${msg.stack}`
        : typeof msg === 'object'
          ? JSON.stringify(msg)
          : msg?.toString()
    )
    .join(', ');
  switch (level) {
    case 'info':
      return getLogger().info(message);
    case 'error':
      return getLogger().error(message);
    case 'warn':
      return getLogger().warn(message);
    case 'debug':
      return getLogger().debug(message);
  }
};

const log = {
  info: (...messages: any[]) => writeLog('info', ...messages),
  error: (...messages: any[]) => writeLog('error', ...messages),
  warn: (...messages: any[]) => writeLog('warn', ...messages),
  debug: (...messages: any[]) => writeLog('debug', ...messages),
};

export default log;
